/**
 * Add item to the cart
 * We want to add the warranty to the cart, along with the product.
 *  
 * @param str variantId - id number of the item to add to the cart 
 * @param str quantity - str(int) of the quantity to add to the cart
 */

async function addItem(variantId, quantity) {
    
    let formData = {
        'items': [{
         'id': variantId,
         'quantity': quantity
         }]
       };

    const result = await fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       })
       .catch((error) => {
         console.error('Error:', error);
       });

    return result;
}



/**
 * Listener to allow us to hide a modal element when outside is clicked
 * 
 * @param str clickElementId - id of the element to listen when clicked
 * @param str modalElementId - id of the element to hide
 */

function setModalListener(clickElementId, modalElementId){
    
    try{
        document.getElementById(clickElementId).addEventListener("click", ()=>{

            const modal = document.getElementById(modalElementId);

            modal.classList.remove("hiddenElement");

            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.classList.add("hiddenElement");
                }
            }
        });
    } catch(err){
        return;
    }
}


/**
 * Listener to allow us to hide a modal element when button is clicked
 * 
 * @param str clickElementId - id of the element to listen when clicked
 * @param str modalElementId - id of the element to hide
 */

function setModalListenerButton(clickElementId, modalElementId){
    const clickElementIdElement = document.getElementById(clickElementId);
    const modalElementIdElement = document.getElementById(modalElementId);

    if(clickElementIdElement && modalElementIdElement){
        clickElementIdElement.addEventListener("click", ()=>{
            modalElementIdElement.classList.add("hiddenElement");
        });
    }
}

function download(file, text) {

    let element = document.createElement('a');

    element.setAttribute('href',
        'data:text/plain;charset=utf-8, '
        + encodeURIComponent(text));

    element.setAttribute('download', file);

    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}


//Set the listeners to hide the modal
setModalListener("warrantyInfoIcon", "warrantyModal");
setModalListenerButton("closeWarrantyModalButton", "warrantyModal");
